module.exports = {
	"name": "winston",
	"description": "A multi-transport async logging library for Node.js",
	"version": "2.3.1",
	"author": "Charlie Robbins <charlie.robbins@gmail.com>",
	"maintainers": [
		"Jarrett Cruger <jcrugzz@gmail.com>",
		"Alberto Pose <albertopose@gmail.com>"
	],
	"repository": {
		"type": "git",
		"url": "https://github.com/winstonjs/winston.git"
	},
	"keywords": [
		"winston",
		"logging",
		"sysadmin",
		"tools"
	],
	"dependencies": {
		"async": "~1.0.0",
		"colors": "1.0.x",
		"cycle": "1.0.x",
		"eyes": "0.1.x",
		"isstream": "0.1.x",
		"stack-trace": "0.0.x"
	},
	"devDependencies": {
		"cross-spawn-async": "^2.0.0",
		"hock": "1.x.x",
		"std-mocks": "~1.0.0",
		"vows": "0.7.x"
	},
	"main": "./lib/winston",
	"scripts": {
		"test": "vows --spec --isolate"
	},
	"engines": {
		"node": ">= 0.10.0"
	},
	"license": "MIT"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/winston/package.json
// module id = 592
// module chunks = 14